<template>
  <div class="idea-status">
    <Icon :icon="displayState.icon" :style="{ color: displayState.color }" />
    <span class="text-truncate">{{ $t(displayState.name) }}</span>
  </div>
</template>

<script>
import ideaHelper from 'commons/ideaHelper/ideaHelper';

export default {
  name: 'IdeaStatus',
  props: {
    idea: {
      type: Object,
    },
    state: {
      type: Object,
    },
  },
  computed: {
    displayState() {
      if (this.idea) {
        return ideaHelper.getState(this.idea);
      } else {
        return this.state;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/styleguide/type';

.idea-status {
  padding: 0 10px 0 0;
  flex-grow: 1;
  display: flex;
  align-items: center;

  .icon {
    width: 20px;
    height: 20px;
  }

  & > span {
    @extend .text-default;
    color: $grey80;
    padding-left: 8px;
    flex-grow: 1;
    width: 100px;
  }
}
</style>
